export default {"src":"/_next/static/media/icon-zero-percent.451116fd.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};